import type { Attrs, EventListeners, Reactive } from "minze";
import { MinzeElement } from "minze";
import { Locale } from "../../modules/locale";
import { SquidexTextLabels } from '../../modules/squidex/labels';
Locale.getInstance().registerKeySet("fr", "tjPopupFormWrapper", {
  alreadySubmitted: "Demande envoyée!\nNous communiquerons avec vous sous peu.",
  closeButton: "Fermer",
});
Locale.getInstance().registerKeySet("en", "tjPopupFormWrapper", {
  alreadySubmitted: `Request sent!\nWe will contact you shortly.`,
  closeButton: "Close",
});
export class TjPopupFormWrapper extends MinzeElement {
  attrs: Attrs = ["data-is-submitted", "false"];
  reactive: Reactive = [["isOpen", false]];
  handleClick = () => {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  };
  renderAlreadySubmitted = () => {
    return `
    <tj-box display="flex" flexDirection="column" justifyContent="center" alignItems="center" padding="30px 0">
    <tj-text class="form-wrapper__already-submitted-text" text-align="center" font-size="20px">
      ${SquidexTextLabels.getKey("tjPopupFormWrapper.alreadySubmitted")}
    </tj-text>
    <tj-box mt="32px" width="fit-content">
      <tj-button id="already-submitted-close-button" width="fit-content" data-button-size="small" fontWeight="700">
       ${SquidexTextLabels.getKey("tjPopupFormWrapper.closeButton")}
      </tj-button>
    </tj-box>
   </tj-box>
    `;
  };
  html = () => `
    <div class="form-wrapper">
      <slot id="open-popup-button" name="open-popup-button"></slot>
      <div class="form-wrapper__popup">
        <div class="form-wrapper__overlay"></div>
        <div class="form-wrapper__content">
          <span id="close-popup-button" name="close-popup-button">&times;</span>
          ${
            this.dataIsSubmitted
              ? `${this.renderAlreadySubmitted()}`
              : `
            <slot name="title"></slot>
            <slot name="content"></slot>
            `
          }
          <tj-background-arrow-icon></tj-background-arrow-icon>
        </div>
      </div>
    </div>
  `;
  css = () => `
    .form-wrapper__popup {
      position: ${this.isOpen ? "fixed" : "static"};
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: ${this.isOpen ? "flex" : "none"};
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px;
      z-index: 1;
    }
    .form-wrapper__content {
      max-width: 600px;
      padding: 40px;
      overflow: auto;
      background: #FFF;
      border-radius: 8px;
      z-index: 2;
      position: relative;
    }
    ::slotted([slot="title"]) {
      margin-bottom: 2rem;
    }
    slot[name="title"] {
      font-size: 34px;
      font-weight: 500;
      color: #133762;
    }
    slot[name="content"] {
      z-index: 2;
      padding: 40px;
      width: 100%;
      position: relative;
      max-height: 90vh;
    }
    .form-wrapper__overlay {
      position: fixed; /* Stay in place */
      z-index: 1; /* Sit on top */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow: auto; /* Enable scroll if needed */
      opacity: 0.4;
      background: rgba(0,0,0,0.5);
    }
    #close-popup-button {
      color: #133762;
      font-size: 28px;
      font-weight: bold;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    #close-popup-button:hover,
    #close-popup-button:focus {
      color: #aaaaaa;
      text-decoration: none;
      cursor: pointer;
    }
    tj-background-arrow-icon {
      position: absolute;
      top: 0;
      left: 0;
    }
    .form-wrapper__already-submitted-text {
      white-space: pre-line;
    }

    @media only screen and (max-width: 600px) {
      .form-wrapper__popup {
        padding: 0;
        justify-content: flex-start;
      }
      .form-wrapper__content {
        height: 100%;
        padding: 60px 16px;
      }
      #close-popup-button {
        top: 2rem;
      }
    }
  `;
  eventListeners: EventListeners = [
    ["#open-popup-button", "click", this.handleClick],
    ["#close-popup-button", "click", this.handleClick],
    ["#already-submitted-close-button", "click", this.handleClick],
    [".form-wrapper__overlay", "click", this.handleClick],
  ];
}
